import React, { useEffect } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useForm, useFormState } from 'react-final-form';

import RenderEntityTableRow from './components/RenderEntityTableRow';

export default function RenderEntityTableRows(): React.ReactElement {
    const formState = useFormState();
    const form = useForm();

    useEffect(() => {
        form.change(
            'sectorNotifications',
            formState.values.sectorNotifications
        );
    }, [form, formState]);

    return (
        <FieldArray name="sectorNotifications">
            {({ fields }) =>
                fields.map((entity, index) => (
                    <RenderEntityTableRow
                        key={entity}
                        id={entity}
                        entityId={fields.value[index]?.entityId}
                    />
                ))
            }
        </FieldArray>
    );
}
